import React from 'react';

const Blog = () => {
    return (
       <div>
         <div className='bg-teal-100 lg:mx-32 md-mx-8 sm-mx-4 mt-5 rounded-md'>
            <p className='text-center p-2 text-blue-600 text-xl'>Queston-01 : what is the purpose of react router</p>
    
            <p className='text-center p-2'>ReactJS Router is mainly used for developing Single Page Web Applications. React Router is used to define multiple routes in the application. When a user types a specific URL into the browser, and if this URL path matches any 'route' inside the router file, the user will be redirected to that particular route.</p>
        </div>
         <div className='bg-teal-100 lg:mx-32 md-mx-8 sm-mx-4 mt-5 rounded-md'>
            <p className='text-center p-2 text-blue-600 text-xl'>Queston-02 : how context api works in react</p>
    
            <p className='text-center p-2'>The React Context API is a way for a React app to effectively produce global variables that can be passed around. This is the alternative to "prop drilling" or moving props from grandparent to child to parent, and so on. Context is also touted as an easier, lighter approach to state management using Redux.</p>
        </div>
         <div className='bg-teal-100 lg:mx-32 md-mx-8 sm-mx-4 mt-5  rounded-md'>
            <p className='text-center p-2 text-blue-600 text-xl'>Queston-03 : how use-href works in react</p>
    
            <p className='text-center p-2'>The useHref hook returns a URL that may be used to link to the given to location, even outside of React Router.</p>
        </div>
       </div>
    );
};

export default Blog;